module.exports = __webpack_public_path__ + "static/media/Milan_WelcomeKit_AR_digital_111119.f869bb87.pdf";